import React, { useState, useEffect } from 'react';
import {Link} from "react-router-dom"
import {FiChevronDown, FiChevronUp} from 'react-icons/fi';

import { db, auth } from '../functions/firebaseFunctions'
export default function ConversationsScreen({ route }) {
    const [Err, setErr] = useState(null);
    const [conversations, setConversations] = useState([]);
    const [locUid, setLocUid] = useState([]);
    const [page, setPage] = useState(1);
    const pageSize = 3;
  
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const displayedItems = conversations.slice(0, endIndex);

    const uid = auth.currentUser?.uid;

    useEffect(() => {
      const promises = [
        db.collection("conversations").where('userA', '==', uid).get(),
        db.collection('conversations').where('userB', '==', uid).get(),
      ];
    
      Promise.all(promises)
        .then(snapshots => {
          const convs = [];
    
          snapshots.forEach(snapshot => {
            snapshot.forEach(doc => {
              const convID = doc.id;
              const conversation = doc.data();
              const locUid = conversation.userA !== uid ? conversation.userA : conversation.userB;
    
              db.collection('users').doc(locUid).get().then(doc => {
                const locData = doc.data()
                convs.push({ ...conversation, id: convID, name: locData.name, locUid: locUid });
                setConversations([...convs]); // установить состояние массива после того, как все документы будут обработаны
              })
            });
          });
        })
        .catch(error => setErr(error));
    }, []);
    

  const handleLoadMore = () => {
    setPage(page + 1);
  };
  const handleLoadHide = () => {
    setPage(1);
  };
      
    return (
        <div style={{ padding: 10, flex: 1,  }} >
          {console.log('conversations', conversations)}
          {conversations.length < 1 && <p style={{color: 'var(--wht)', textAlign: 'center'}}>You have not started a conversation yet.</p>}
            <div
                style={{ flex: 1, backgroundColor: 'var(--drg)' }}
                behavior="padding"
                // keyboardVerticalOffset={70}
            >
                <div style={{ height: 2, width: '100%' }} />
                {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
                <div
                    style={{
                        flex: 1,
                        // padding: 10, 
                        justifyContent: "flex-end"
                    }}>
                    {displayedItems && 
                    displayedItems
                    .sort((a, b) => (b.hasNewMessages === uid) - (a.hasNewMessages === uid))
                    .map(item => 
                      <div key={item.id} >
                        <Link to={`/messages/${item.locUid}%26${item.id}%26${item.name}`} style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', cursor: 'pointer', }}>
                          
                          <p style={{fontSize: 18, color: 'white', animation: item.hasNewMessages === uid && 'colorYORP 8s linear infinite' }}> {item.name} </p>
                        </Link>
                        <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                      </div>
                    )}
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      {conversations.length > endIndex ?
                        <button className='BrowseButton'
                          style={{ color: 'var(--ltg)', paddingBlock: '10px 0px'}} 
                          onClick={handleLoadMore}>
                            Show more <FiChevronDown /> 
                        </button> : 
                        conversations.length > 3 &&
                        <button className='BrowseButton'
                          style={{ color: 'var(--ltg)', paddingBlock: '10px 0px'}} 
                          onClick={handleLoadHide}>
                            Hide <FiChevronUp />
                        </button>
                        }
                    </div>
                </div>
                <div>
                </div>
            </div>
        </div>
    )
}